import React, { useCallback } from 'react';
import { svgSprite, Tooltip } from '../../../../../hybrid/wrappers';
import T, { t } from '../../../../../common/components/T';
import css from './NoReferal.module.scss';
import classnames from 'classnames';

const NoReferal = ({ inp, setInp, title, disabled, setFormData, attribute, switchHint, translation }) => {
    const changeInputHandler = useCallback(
        (v, statusInput) => {
            if (!disabled) {
                let value = v.length > 150 ? v.substr(0, 149) : v;
                if (value.length === 0 && statusInput) value = null;
                setFormData(attribute, value);
                setInp({ val: value, showInput: statusInput });
            }
        },
        [disabled, setFormData, attribute, setInp]
    );
    const changeTabHandler = useCallback(() => {
        if (!disabled) {
            changeInputHandler('', !inp.showInput);
        }
    }, [disabled, inp, changeInputHandler]);
    return (
        <div className={css.formSponsorBlock}>
            {!!title && (
                <div className={css.formSponsorTextBlock}>
                    <p className={css.formSponsorBlockTitle}> {title.body} </p>
                    <div style={{ position: 'relative' }}>
                        <Tooltip
                            text={
                                <p className={css.formSponsorTooltip}>
                                    {switchHint ||
                                        t(
                                            'FormSponsorWidget-switchHint',
                                            'Введите логин спонсора, чтобы попасть в структуру партнера, который Вас пригласил',
                                            'widget',
                                            translation,
                                            'form'
                                        )}
                                </p>
                            }
                            compStyle={{ inner: css.formSponsorIconWrap }}
                            place='top'
                        >
                            {svgSprite('info-circle', {
                                className: css.formInfoIcon
                            })}
                        </Tooltip>
                    </div>
                </div>
            )}
            <div onClick={changeTabHandler} className={css.formSponsorTab}>
                <div
                    className={css.formSponsorTabElement}
                    style={
                        inp.showInput
                            ? {
                                  left: '2px',
                                  transition: '.3s'
                              }
                            : { left: 'calc(100% - 70px)', transition: '.3s' }
                    }
                />
                <div style={{ zIndex: '1' }} className={classnames(css.formSponsorTabText)}>
                    <p className={inp.showInput ? css.formSponsorTabTextActive : css.formSponsorTabTextNotActive}>
                        <T textName='yes' defaultStr='Да' page='all' />
                    </p>
                    <p className={!inp.showInput ? css.formSponsorTabTextActive : css.formSponsorTabTextNotActive}>
                        <T textName='no' defaultStr='Нет' page='all' />
                    </p>
                </div>
            </div>
        </div>
    );
};
export default NoReferal;
